module.exports = __webpack_public_path__ + "static/media/acorn.d1c468ca.svg";